import { useEffect } from "react";

const currentBundle = () => [...document.scripts].map((s) => s.src).find((s) => /\/static\/js\/main\.[^/]+\.js/.test(s));

// Herlaadt de app wanneer er een nieuwe versie gepubliceerd is (bij terugkeren naar de app of elke 10 min).
export const useAutoUpdate = () => {
  useEffect(() => {
    const mine = currentBundle();
    if (!mine) return undefined;
    const check = async () => {
      if (document.visibilityState !== "visible") return;
      try {
        const html = await (await fetch(`/?v=${Date.now()}`, { cache: "no-store" })).text();
        const m = html.match(/\/static\/js\/main\.[^"']+\.js/);
        if (m && !mine.endsWith(m[0])) window.location.reload();
      } catch { /* offline */ }
    };
    const id = setInterval(check, 600000);
    document.addEventListener("visibilitychange", check);
    window.addEventListener("focus", check);
    return () => { clearInterval(id); document.removeEventListener("visibilitychange", check); window.removeEventListener("focus", check); };
  }, []);
};
